import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import { FetchUserTeams, FetchUserTeamsFailure, FetchUserTeamsSuccess } from './actions';
import { UserState } from 'app/projects/user/src/lib/models/user.state';

@Injectable()
export class UserTeamsResolver  {
    constructor(private _store: Store, private actionHelper: NgxsActionHelper) {}

    resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
        const user = this._store.selectSnapshot(UserState.getMyInfo);

        const userId = route.parent.params['id'] || user.id;

        this._store.dispatch(new FetchUserTeams({ userId }));

        return this.actionHelper.race(FetchUserTeamsSuccess, FetchUserTeamsFailure);
    }
}
